import React, { useCallback, useState } from 'react';
import { AutocompleteComponent } from '../../../../../../Components';
import { useDebouncedAction } from '../../../../../../Hooks/DebouncedAction';
import { OrganizationUserSearch } from '../../../../../../Services';

const AssignedToAutocomplete = ({ parentTranslationPath, onSelect }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const getAllActivityAssignments = useCallback(
    useDebouncedAction(async (e) => {
      setIsLoading(true);
      if (e.target?.value === 0) return;
      const res = await OrganizationUserSearch({
        pageIndex: 0,
        pageSize: 50,
        name: e.target?.value,
        userStatusId: 2,
      });
      if (!(res && res.status && res.status !== 200)) {
        setData(res.result);
      }
      setIsLoading(false);
    }),
    []
  );
  return (
    <AutocompleteComponent
      idRef='assignAgentIdRef'
      labelValue='activity-assign-to'
      labelClasses='Requierd-Color'
      wrapperClasses={'w-25'}
      multiple={false}
      data={data}
      displayLabel={(option) => option.fullName}
      renderOption={(option) =>
        ((option.userName || option.fullName) &&
          `${option.fullName} (${option.userName})`) ||
        ''
      }
      getOptionSelected={(option, value) => option.id === value.id}
      withoutSearchButton
      isLoading={isLoading}
      onInputChange={(e) => {
        e.persist();
        getAllActivityAssignments(e);
      }}
      parentTranslationPath={parentTranslationPath}
      onChange={(e, newValue) => {
        onSelect(newValue);
      }}
    />
  );
};
export default AssignedToAutocomplete;
